import { css } from '@emotion/react';

export const CheckResultItemStyles = () => ({
    main: () => css`
        .check-result-item__title {
            font-size: 14px;
        }
    `
})